import { render } from "./SearchResults.vue?vue&type=template&id=313c23e5"
import script from "./SearchResults.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SearchResults.vue?vue&type=script&charset=utf-8&lang=js"

import "./SearchResults.vue?vue&type=style&index=0&id=313c23e5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__